// Doc / KB taxonomies — moved out of workspace-project/state.js so the
// constants live with the documents surface that consumes them.

// `label` carries a polyglot KEY, not a string. Every render site resolves it
// through `el.call('polyglot', …)`, and translate() returns a non-key verbatim
// — which is what keeps a USER-CREATED folder (its label is the raw folderPath)
// rendering as itself alongside these.
export const DOC_FOLDERS = Object.freeze([
  { key: 'all', label: 'documents.folder.notes', icon: 'folder' },
  { key: 'company', label: 'documents.folder.company', icon: 'flag' },
  { key: 'legal', label: 'documents.folder.legal', icon: 'bookmark' },
  { key: 'finance', label: 'documents.folder.finance', icon: 'document' },
  { key: 'people', label: 'documents.folder.people', icon: 'people' },
  { key: 'engineering', label: 'documents.folder.engineering', icon: 'code' },
  { key: 'design', label: 'documents.folder.design', icon: 'eye' }
])

export const KB_CATEGORIES = Object.freeze([
  { key: 'all', label: 'documents.kbCategory.all', icon: 'document' },
  { key: 'getting-started', label: 'documents.kbCategory.gettingStarted', icon: 'star' },
  { key: 'engineering', label: 'documents.kbCategory.engineering', icon: 'code' },
  { key: 'design', label: 'documents.kbCategory.design', icon: 'eye' },
  { key: 'policies', label: 'documents.kbCategory.policies', icon: 'bookmark' },
  { key: 'tools', label: 'documents.kbCategory.tools', icon: 'settings' }
])
